import React, { useState, useEffect } from "react";
import { Icon, Row, Col, Button, Statistic, Progress } from "antd";
import moment from "moment";

import useInterval from "../../hooks/useInterval";
import { secons2text } from "../../services/timeFunctions";

//import { useDispatch } from "react-redux";
//import { figurenames, figures } from "../../constants";

// Styles
import { Wrapper, H3 } from "./styles";

import Table from "../../components/table";
import Search from "../../components/table/search";

import { marksAgitation } from "../../constants";

// Hooks
import useManufacturingOrder from "../../hooks/useManufacturingOrder";

//import multilanguage library
import { useTranslation } from "react-i18next";

const RenderQuenching = ({ quenchingStatus }) => {
  const [manufacturingList, setManufacturingList] = useState(null);
  const [quenchingArticle, setQuenchingArticle] = useState(null);
  const [furnaceArticle, setFurnaceArticle] = useState(null);

  const [, /*furnaceNowTemperature*/ setFurnaceNowTemperature] = useState(750);

  const { manufacturingOrder, updateData } = useManufacturingOrder();

  //To translate text
  const { t } = useTranslation();

  //To refresh time to out furnace
  useInterval(() => {
    //set same value
    setQuenchingArticle([...quenchingArticle]);
  }, 30000);

  useEffect(() => {
    let temp = localStorage.getItem("furnaceTemp");
    if (temp) setFurnaceNowTemperature(parseInt(temp));
  }, []);

  useEffect(() => {
    const filtered = manufacturingOrder.filter((order, i) => order.desing);
    const normalized = filtered.map((order, i) => {
      return {
        key: i,
        ...order,
      };
    });

    const quenchingList = [];
    const intoFurnaceList = [];
    filtered.forEach((order, i) => {
      order.pieces.forEach((piece, x) => {
        let a = {
          key: "que-" + x + "-" + piece.id,
          ...piece,
          name: order.name,
          furnace: {
            time: order.desing.recommendation.furnace_time,
            temperature: order.desing.furnace.temperature,
            ...piece.furnace,
          },
          quenching: {
            bath_type: order.desing.quenching.bath_type,
            bath_temperature: order.desing.quenching.bath_temperature,
            agitation_level: order.desing.quenching.agitation_level,
            ...piece.quenching,
          },
        };
        if (piece.quenching && piece.quenching.start && !piece.quenching.end) quenchingList.push(a);
        if (piece.furnace && piece.furnace.start && !piece.furnace.end) intoFurnaceList.push(a);
      });
    });

    setQuenchingArticle(quenchingList);
    setFurnaceArticle(intoFurnaceList);

    normalized && setManufacturingList(normalized);
  }, [manufacturingOrder]);

  const columnsOrders = [
    {
      title: t("table.header.ref"),
      dataIndex: "name",
      key: "name",
      sorter: (a, b) => a.name.localeCompare(b.name),
      defaultSortOrder: "descend",
    },
    {
      title: t("table.header.article"),
      dataIndex: "article.name",
      key: "article.name",
    },
    {
      title: t("table.header.percent_pieces_quenching"),
      dataIndex: "pieces",
      key: "pieces",
      render: (text, record) => {
        if (!record.pieces) return;
        //Furnace end in each piece
        let ended = record.pieces.reduce((total, x) => (x.quenching && x.quenching.end ? total + 1 : total), 0);
        let percent = parseInt((100 * ended) / record.pieces.length);

        return (
          <div style={{ width: "100%" }}>
            <Progress percent={percent} size="small" />
          </div>
        );
      },
    },
  ];

  const columnsAvailable = [
    {
      title: t("table.header.ref"),
      dataIndex: "name",
      key: "name",
      sorter: (a, b) => a.name.localeCompare(b.name),
      defaultSortOrder: "descend",
      ...Search("name"),
    },
    {
      title: t("table.header.number"),
      dataIndex: "id",
      key: "id",
    },
    {
      title: t("table.header.temperature"),
      dataIndex: "quenching.bath_temperature",
      key: "quenching.bath_temperature",
    },
    {
      title: t("table.header.agitation"),
      dataIndex: "quenching.agitation_level",
      key: "quenching.agitation_level",
      render: (value) => marksAgitation[value],
    },
    {
      title: t("table.header.entry_date"),
      dataIndex: "quenching.start",
      key: "quenching.start",
      render: (value) => value.format("DD/MM/YYYY HH:mm:ss"),
    },
    {
      title: t("table.header.time"),
      dataIndex: "quenching.start",
      key: "furnace.bath_temperature",
      render: (time, record) => {
        let start_sec = time.unix();
        let plusTime = record.quenching.plusTime ? record.quenching.plusTime : 0;
        let this_sec = moment().unix() + plusTime; //This is for demo

        return <h3>{secons2text(this_sec - start_sec)}</h3>;
        //time.format("HH:mm:ss");
      },
    },
    {
      title: t("table.header.action"),
      dataIndex: "furnace",
      key: "furnace",
      render: (text, record) => {
        return (
          <div
            style={
              {
                /*width: 170*/
              }
            }
          >
            <Button type="link" size="small" onClick={() => article2out(record.id, record.name)}>
              {t("button.action.take")}
              <Icon type="right" />
            </Button>
          </div>
        );
      },
    },
  ];

  const columnsFurnace = [
    {
      title: t("table.header.ref"),
      dataIndex: "name",
      key: "name",
      sorter: (a, b) => a.name.localeCompare(b.name),
      defaultSortOrder: "descend",
    },
    {
      title: t("table.header.number"),
      dataIndex: "id",
      key: "id",
    },
    {
      title: t("table.header.entry_date"),
      dataIndex: "furnace.start",
      key: "furnace.start",
      render: (value) => value.format("DD/MM/YYYY HH:mm:ss"),
    },
    {
      title: t("table.header.agitation"),
      dataIndex: "quenching.agitation_level",
      key: "quenching.agitation_level",
      render: (value) => marksAgitation[value],
    },
    {
      title: t("table.header.temperature"),
      dataIndex: "quenching.bath_temperature",
      key: "quenching.bath_temperature",
    },
    {
      title: t("table.header.remaining_time"),
      dataIndex: "furnace.time",
      key: "furnace",
      render: (time, record) => {
        let start_sec = record.furnace.start.unix();
        let end_sec = start_sec + time;

        let plusTime = record.furnace.plusTime ? record.furnace.plusTime : 0;
        let this_sec = moment().unix() + plusTime; //This is for demo
        //this_sec += 7000 //Prueba de color
        let difference = end_sec - this_sec;
        let negative = difference < 0;

        return negative ? <h3 style={{ color: "red" }}>{"- " + secons2text(-1 * difference)}</h3> : <h3>{secons2text(difference)}</h3>;

        //return <h3>{secons2Dhm(end_sec-this_sec)}</h3>
        //time.format("HH:mm:ss");
      },
    },
  ];

  const article2out = (id, name) => {
    let order = manufacturingOrder.find((obj) => obj.name === name);
    let list = order.pieces.map((obj) => {
      if (obj.id === id) {
        return {
          ...obj,
          quenching: {
            ...obj.quenching,
            end: moment(),
          },
        };
      } else return obj;
    });
    order.pieces = list;
    updateData(order);
  };

  const timeRunQuenching = (seconds) => {
    manufacturingOrder.forEach((order) => {
      if (order.making) {
        let list = order.pieces.map((obj) => {
          if (obj.quenching && obj.quenching.start && !obj.quenching.end) {
            let plusTime = obj.quenching.plusTime ? obj.quenching.plusTime : 0;

            return {
              ...obj,
              quenching: {
                ...obj.quenching,
                plusTime: plusTime + seconds,
              },
            };
          } else return obj;
        });
        order.pieces = list;
        updateData(order);
      }
    });
  };

  return (
    <Wrapper>
      <Row style={{ margin: 0 }} gutter={[16, 16]}>
        <Col xl={10} lg={10} md={24}>
          <H3>{t("headers.control_process.pieces_in_furnace", { value: furnaceArticle && furnaceArticle.length })}</H3>
          <Table data={furnaceArticle} columns={columnsFurnace} size="small" />
        </Col>
        <Col xl={2} lg={4} md={24} style={{ height: "calc(70vh)" }}>
          <H3>{t("headers.control_process.status")}</H3>
          <Col span={24}>
            <Statistic
              title={t("labels.state.quenching_temp")}
              value={quenchingStatus && quenchingStatus.bath_temperature}
              precision={2}
              suffix="ºC"
              style={{ textAlign: "center" }}
            />
          </Col>
          <Col span={24}>
            <Statistic
              title={t("labels.state.quenching_type")}
              value={quenchingStatus && t("labels.quenching.bath_type." + quenchingStatus.bath_type)}
              style={{ textAlign: "center" }}
            />
          </Col>
          <Col span={24}>
            <Statistic
              title={t("labels.state.agitation_level")}
              value={quenchingStatus && quenchingStatus.agitation_level && marksAgitation[quenchingStatus.agitation_level]}
              precision={2}
              suffix="m/s"
              style={{ textAlign: "center" }}
            />
          </Col>
        </Col>
        <Col xl={12} lg={10} md={24} style={{ height: "calc(60vh - 210px)" }}>
          <Row>
            <Col span={8}></Col>
            <Col span={8}>
              <H3>{t("headers.control_process.pieces_in_quenching", { value: quenchingArticle && quenchingArticle.length })}</H3>
            </Col>
            <Col span={8}>
              <Button type="link" size="small" style={{ float: "right" }} onClick={() => timeRunQuenching(600)}>
                <Icon type="clock-circle" />
                {t("button.advance_time", { time: 10 })}
              </Button>
            </Col>
          </Row>
          <Table data={quenchingArticle} columns={columnsAvailable} pagination={{ pageSize: 5 }} size="small" />
        </Col>
        <Col xl={12} lg={24} md={24}>
          <H3>{t("headers.control_process.manufacturing_order")}</H3>
          <Table data={manufacturingList} columns={columnsOrders} pagination={{ pageSize: 4 }} size="small" />
        </Col>
      </Row>
    </Wrapper>
  );
};
export default RenderQuenching;
